import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from 'src/app/models/auth';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CedenteService } from 'src/app/services/cedente.service';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { VehicleService } from 'src/app/services/vehicles.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';

@Component({
    selector: 'app-dado-empresa-detail',
    templateUrl: './dado-empresa-detail.component.html',
    styleUrls: ['./dado-empresa-detail.component.scss'],
})
export class DadoEmpresaDetailComponent implements OnInit {
    private currentUser: Auth;
    public addressTypes: any;    
    private parametros: { [key: string]: string };
    public settingsLog: { receipt: boolean, odometer: boolean  };
    temContaSeuValeLog = false;
    notaFiscalDetalhada = false;
    inputNotaFiscalDetalhada = false;
    textoNotaFiscalDetalhada = "";

    constructor(
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private router: Router,
        private route: ActivatedRoute,
        private vehicleService: VehicleService,
        private parametrosDataService: ParametrosDataService,
        private cedenteService: CedenteService) {}

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.temContaSeuValeLog = BooleanConverter.getBoolean(this.parametrosDataService.currentParametrosValue[ParametrosKey.temContaSeuValeLog]);

        this.parametros = this.parametrosDataService.currentParametrosValue;
        if (this.parametros) {
            if (this.parametros[ParametrosKey.notaFiscalDetalhada] &&
                BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.notaFiscalDetalhada]
                )) {
                    this.notaFiscalDetalhada = true;
                    this.inputNotaFiscalDetalhada = true;
            }
            if (
                this.parametros[
                ParametrosKey.textoNotaFiscalDetalhada
                ]
            ) {
                this.textoNotaFiscalDetalhada = this.parametros[
                    ParametrosKey.textoNotaFiscalDetalhada
                ];            
            }
        }

        this.getAddressTypes();
        this.getSettingsLogistics();
    }

    private getAddressTypes() {
        this.cedenteService.getAddressTypes().subscribe(
            response => {
                this.addressTypes = response.result;
            }, error => {
                this.alertService.error(error.message)
            }
        )
    }

    getSettingsLogistics() {
        if (this.temContaSeuValeLog) {
            this.vehicleService.getSettingsLogistics(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId)
                .subscribe(response => {
                    if (response.status === ApiError.Sucesso) {
                        this.settingsLog = response.result;
                    } else {
                        this.alertService.error("Falha ao carregar configuração do Bankei LOG", true);
                    }
                });
        }

    }

    receiptEnableDisable(receipt: boolean) {
        this.vehicleService.updateSettingsLogistics(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, receipt)
            .subscribe(response => {
                if (response.status === ApiError.Sucesso) {
                    this.alertService.success("Atualizado com sucesso!", true);
                } else {
                    this.alertService.error("Falha ao atualizar situação do veículo", true);
                }
            });
    }

    odometerEnableDisable(odometer: boolean) {
        this.vehicleService.updateSettingsLogistics(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, null,odometer)
            .subscribe(response => {
                if (response.status === ApiError.Sucesso) {
                    this.alertService.success("Atualizado com sucesso!", true);
                } else {
                    this.alertService.error("Falha ao atualizar situação do veículo", true);
                }
            });
    }
    
    nfsEnableDisable(nfs: boolean) {
        this.inputNotaFiscalDetalhada = nfs;

        if(!nfs)
            this.nfsSave();
    }

    nfsSave() {
        const parameters = [
            {
                key: ParametrosKey.notaFiscalDetalhada,
                value: this.notaFiscalDetalhada.toString()
            },
            {
                key: ParametrosKey.textoNotaFiscalDetalhada,
                value: this.textoNotaFiscalDetalhada
            }
        ]

        this.parametrosDataService.updateParameters(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, parameters)
            .subscribe(response => {
                if (response.status === ApiError.Sucesso) {
                    this.alertService.success("Configurações atualizadas com sucesso!", true);
                } else {
                    this.alertService.error("Falha ao atualizar as configurações", true);
                }
            });
    }

    public normalize(phone) {
        if (phone == null)
            return phone;
        //normalize string and remove all unnecessary characters
        phone = phone.replace(/[^\d]/g, "");

        //check if number length equals to 10
        if (phone.length <= 10) {
            //reformat and return phone number
            return phone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
        }else if (phone.length > 10) {
            //reformat and return phone number
            return phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
        }

        return "null";
    }

    edit() {
        this.router.navigate([`edit`], {relativeTo: this.route.parent});       
    }
}
